import _extends from "@babel/runtime/helpers/esm/extends";
import { createElement } from "@wordpress/element";

/**
 * WordPress dependencies
 */
import { createContext, useContext } from '@wordpress/element';
/**
 * Internal dependencies
 */

import { getLayoutType } from '../../layouts';
export const defaultLayout = {
  type: 'default'
};
const Layout = createContext(defaultLayout);
/**
 * Allows to define the layout.
 */

export const LayoutProvider = Layout.Provider;
/**
 * React hook used to retrieve the layout config.
 */

export function useLayout() {
  return useContext(Layout);
}
export function LayoutStyle(_ref) {
  let {
    layout = {},
    ...props
  } = _ref;
  const layoutType = getLayoutType(layout.type);

  if (layoutType) {
    return createElement(layoutType.save, _extends({
      layout: layout
    }, props));
  }

  return null;
}
//# sourceMappingURL=layout.js.map